export const medicineCategories = ["Tablets", "Ointments", "Injections", "Syrups", "Others"] as const;

export const medicineCategory = (medicine?: { type?: string } | null) => {
  const type = String(medicine?.type || "").trim().toLowerCase();
  if (/^(tablets?|tab|capsules?|cap|lozenges?)$/.test(type)) return "Tablets";
  if (["ointment", "cream", "gel", "lotion"].includes(type)) return "Ointments";
  if (["injection", "infusion"].includes(type)) return "Injections";
  if (/^(syrups?|syp|suspensions?|susp)$/.test(type)) return "Syrups";
  return "Others";
};

export const groupPrescriptionMedicines = <T extends { medicine?: { type?: string } | null }>(items: T[]): T[] =>
  medicineCategories.flatMap((category) => items.filter((item) => medicineCategory(item.medicine) === category));
